import { array, boolean, nativeEnum, object, string, TypeOf } from 'zod';

import { CornerStyle, LabelSize, Link, Margin, Position } from './common';

/* ------------------------------- LabelMargin ------------------------------ */

export const LabelMargin = object({
    vertical: nativeEnum(Margin),
    horizontal: nativeEnum(Margin),
});
export type LabelMargin = TypeOf<typeof LabelMargin>;

/* ------------------------------- LabelColor ------------------------------- */

export const LabelColor = object({
    background: string(),
    text: string(),
});
export type LabelColor = TypeOf<typeof LabelColor>;

/* ------------------------------ LabelDisplay ------------------------------ */

export const LabelDisplay = object({
    color: LabelColor,
    cornerStyle: nativeEnum(CornerStyle),
    enabled: boolean(),
    margin: LabelMargin,
    position: nativeEnum(Position),
    size: nativeEnum(LabelSize),
});
export type LabelDisplay = TypeOf<typeof LabelDisplay>;

/* ---------------------------------- Label --------------------------------- */

export const Label = object({
    id: string(),
    name: string(),
    display: object({
        tile: LabelDisplay,
        item: LabelDisplay,
    })
        .deepPartial()
        .optional(),
    image: object({
        master: string(),
        tile: string().optional(),
        item: string().optional(),
    }).optional(),
    link: Link.optional(),
});
export type Label = TypeOf<typeof Label>;

/* -------------------------------- AllLabels ------------------------------- */

export const AllLabels = object({
    data: array(Label),
});
export type AllLabels = TypeOf<typeof AllLabels>;
